import FormVue from './form-vue.pug';
import Api from '../../../base/script/api';
import UtmData from '../../../base/script/utmData';
import InputCountry from '../../../core/input/country/input-country';

export default {
  props: {
    dataForm: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      formComplete: false,
      showError: false,
      nameValid: true,
      form: this.dataForm,
      formData: {
        type: 'call',
        phone: null,
        name: null,
        room_id: this.dataForm.id,
        second_name: '',
      },
    };
  },
  template: FormVue(),
  delimiters: ['${', '}}'],
  components: {
    InputCountry,
  },
  methods: {
    submit() {
      let nameValid = true;
      if (this.nameValidation) {
        nameValid = this.formData.name && this.formData.name.length > 0;
      }
      if (nameValid && this.formComplete) {
        this.sendForm();
      }
      this.showError = !this.formComplete;
      if (this.nameValidation) {
        this.nameValid = this.formData.name && this.formData.name.length > 0;
      }
    },
    completeForm(phone) {
      this.formComplete = true;
      this.formData.phone = phone;
    },
    acceptForm(value) {
      this.formComplete = false;
      if (value.length === 0) this.showError = false;
    },
    validateField(e) {
      if (this.nameValidation) {
        this.nameValid = e.target.value.length > 0;
      }
    },
    getPhonePrefix() {
      const phoneInput = this.$el.querySelector('input[data-phone-prefix]');
      if (phoneInput) {
        return `${phoneInput.getAttribute('data-phone-prefix')} `;
      }
      return '';
    },
    sendForm() {
      new UtmData(this.formData);

      const copyObject = Object.assign({}, this.formData);
      copyObject.phone = `${this.getPhonePrefix()}${copyObject.phone}`;
      copyObject.stateless = window.stateless || 0;

      Api.post(this.$el.action, copyObject)
        .then((response) => {
          const { data } = response;
          this.$el.reset();
          // this.formData.phone = null;
          // if (this.formData.name) this.formData.name = null;
          // this.formData.type = 'call';
          if (this.nameValidation) {
            this.nameValid = true;
          }
          if (window.ga) {
            window.ga('send', {
              hitType: 'event',
              eventAction: 'lead',
              eventLabel: 'form',
            });
          }
          if (data.success) {
            if (this.formData.type) {
              if (this.formData.type === 'call') {
                if (window.Comagic && window.Comagic.addOfflineRequest) {
                  window.Comagic.addOfflineRequest({
                    name: this.formData.name,
                    phone: this.formData.phone,
                  });
                }
              } else if (this.formData.type === 'whatsapp') {
                const chatData = {
                  url: window.location.href,
                  title: document.title,
                  channel: 'whatsapp',
                  Client_name: this.formData.name,
                  phone: this.formData.phone.replace(/\D/g, ''),
                };
                Api.post('https://api.chat2desk.com/webhooks/smart_script/MeCzLzE', chatData);
              }
            }
            window.openSuccessPopup();
            this.$emit('successform', data);
          }
        });
    },
  },
  mounted() {
    this.submitEl = this.$refs.submitBtn;
  },
};



// WEBPACK FOOTER //
// ./blocks/form/vue/form-vue.js